import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import ContentView from 'material-ui/svg-icons/image/remove-red-eye';

const styles = {
    icon: {overflow: 'inherit'},
};

const ViewButton = ({ basePath = '', record = {} }) => (
    <IconButton
        containerElement={<Link to={`${basePath}/${record.id}/show`} />}
        style={styles.icon}
    >
        <ContentView color={FuseTheme.palette.primary1Color} />
    </IconButton>
);

ViewButton.propTypes = {
    basePath: PropTypes.string,
    record: PropTypes.object,
};

ViewButton.defaultProps = {
    style: { padding: 0 },
};

export default ViewButton;


// WEBPACK FOOTER //
// ./src/Fuse/buttons/ViewButton.js